module.exports = __webpack_public_path__ + "img/symbol-8-center.a72e287d.png";